import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './PaymentsList.css';

type PaymentAddButtonProps = {
    click: () => void;
};

export default function PaymentAddButton({ click }: PaymentAddButtonProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="pt-1 ion-text-center">
        <IonButton
          fill="outline"
          className="btn-default btn-inverted btn-wide-80"
          onClick={() => click()}
        >
          <IonIcon slot="start" src={'assets/icon/card-inv.svg'}></IonIcon>
          {t('payments.add')}
        </IonButton>
      </div>
    </>
  );
}
